/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsDashboardApplicationDetails extends models.AppSecopsApplication {
    getFixupPrototypeFunction() { return AppSecopsDashboardApplicationDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsDashboardApplicationDetails>): AppSecopsDashboardApplicationDetails {
        let obj = Object.assign(new AppSecopsDashboardApplicationDetails(), model);
        AppSecopsDashboardApplicationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsDashboardApplicationDetails>): AppSecopsDashboardApplicationDetails {
        if (!model) return null;
        return AppSecopsDashboardApplicationDetails.newInstance(<AppSecopsDashboardApplicationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsDashboardApplicationDetails) {
        if (!obj) return;

        models.AppSecopsDashboardApplicationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsDashboardApplicationDetails): boolean {
        if (models.AppSecopsApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsDashboardApplicationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.projects) {
            for (let val of this.projects) {
                models.AppSecopsProject.fixupPrototype(val);
            }
        }
    }

    /**
     * Project details associated with the application
     */
    projects: Array<models.AppSecopsProject>;

}
